import { useState, useEffect, useReducer } from 'react'
import { Switch, Route, useParams } from 'react-router-dom'

import { Flex } from '../../../../primitives'

import Branch from '../Branch'
import UnitPrice from '../UnitPrice'

import Table from './Table'
import Form from './Form'

import reducer, { initialState } from './state'

const MODULE_PATH = '/operations/:zone+/customers'

function Customer() {
  const params = useParams()

  const [state, dispatchState] = useReducer(reducer, initialState)

  const [modulePath, setModulePath] = useState(MODULE_PATH)

  useEffect(() => {
    if (params?.zone) {
      setModulePath(MODULE_PATH.replace(':zone+', params.zone))
    }
  }, [params?.zone])

  return (
    <Flex axisGap={400} direction='column'>
      <Switch>
        <Route path={`${MODULE_PATH}/branches`}>
          <Branch
            organizationId={state.organizationId}
            customerId={state.customerId}
            backPath={modulePath}
          />
        </Route>
        <Route path={`${MODULE_PATH}/unit-prices`}>
          <UnitPrice
            organizationId={state.organizationId}
            customerId={state.customerId}
            backPath={modulePath}
          />
        </Route>
        <Route
          path={[`${MODULE_PATH}/create`, `${MODULE_PATH}/update/:itemId`]}
          exact={true}
        >
          <Form
            state={state}
            dispatchState={dispatchState}
            modulePath={modulePath}
          />
        </Route>
        <Route path={MODULE_PATH} exact={true}>
          <Table
            state={state}
            dispatchState={dispatchState}
            modulePath={modulePath}
          />
        </Route>
      </Switch>
    </Flex>
  )
}

export default Customer
